// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-budget-report .txt{font-size:14px;margin-bottom:10px;margin-top:20px;color:#51606d}.filter-budget-report .reset-filters{margin-top:25px;color:#013893;cursor:pointer}.filter-budget-report .buttons{display:flex;flex-direction:row-reverse;margin-top:60px;margin-bottom:50px}.filter-budget-report .buttons #btn-filter-budget{margin-left:15px}\n", ""]);
// Exports
module.exports = exports;
